function playHz(idn) {
    document.getElementById(idn).play();
    document.getElementById(idn).controls = true;
    setInterval(function () {
        if ($("#" + idn).prop("ended")) {
            $("#" + idn)
                .siblings(".play_btn")
                .fadeIn();
            document.getElementById(idn).controls = false;
        }
    }, 200);
}
function pauseHz(idn) {
    document.getElementById(idn).pause();
    document.getElementById(idn).controls = false;
}

(function () {
    var slideLength = $(".product_item_swiper .swiper-slide").length;
    if ($(window).width() > 768) {
        if (slideLength <= 4) {
            var numindex = slideLength - 1;
        }
        if (slideLength > 4) {
            var numindex = 3;
        }
    }
    if ($(window).width() <= 768) {
        var numindex = 0;
    }

    // 221227 수정
    var primeSwiper = new Swiper(".prime_swiper", {
        effect: "fade",
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".product_item_next",
            prevEl: ".product_item_prev",
        },
        pagination: {
            el: ".product_item_pagination",
            type: "custom",
            renderCustom: function (displaySwiper, current, total) {
                var customPaginationHtml = "";
                var total_index = $(".prime_swiper .swiper-slide:not(.swiper-slide-duplicate)").length;
                var fraction =
                    current + '<span class="space">/</span>' + '<span class="num_total">' + total_index + "</span>";
                return fraction;
            },
        },
        on: {
            activeIndexChange: function () {
                $(".prime_swiper .pagination button")
                    .eq(this.realIndex)
                    .addClass("active")
                    .siblings("button")
                    .removeClass("active");
            },
        },
    });
    $(".prime_swiper .pagination button").click(function () {
        // 22.01.03 수정
        var i = $(this).index() + 1;
        $(this).addClass("active").siblings("button").removeClass("active");
        primeSwiper.slideTo(i);
    });

    // 비디오 재생 아이콘
    $(".play_btn").click(function () {
        $(this).fadeOut();
    });
    $(".item.right .btn_more").click(function () {
        $(this).siblings(".video").children(".play_btn").fadeIn();
    });

    // 인터뷰 영상 노출
    $(".btn_right").click(function () {
        offsetY = window.pageYOffset;
        $("body").addClass("scrollDisable");
        $(this).parents(".cont").children(".item.right").addClass("on");
        $(".to_top").hide().css({ opacity: 0 });
    });
    $(".btn_left").click(function () {
        $("body").removeClass("scrollDisable");
        $(window).scrollTop(offsetY);
        $(this).parents(".cont").children(".item.right").removeClass("on");
        $(".to_top").show().css({ opacity: 1 });
    });

    // 모바일 3step text box
    var stepSwiper = new Swiper(".m_box_wrap", {
        slidesPerView: 1.2,
        spaceBetween: 20,
        centeredSlides: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        on: {
            slideChangeTransitionEnd: function () {
                var index = parseInt(stepSwiper.slides[stepSwiper.activeIndex].getAttribute("data-index"));
                $(".box_wrap .box").eq(index).addClass("active").siblings(".box").removeClass("active");
            },
        },
    });
    $(".box_wrap .box").click(function () {
        $(this).addClass("active").siblings(".box").removeClass("active");
        stepSwiper.slideTo(Number($(this).data("index")));
    });

    // 통이미지 swiper
    /*  var displaySwiper = new Swiper(".scroll-swiper", {
        freeMode: true,
        slidesPerView: "auto",
        freeMode: true,
    });
    */
    function optimizeAnimation(callback) {
        let ticking = false;
        return () => {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(() => {
                    callback();
                    ticking = false;
                });
            }
        };
    }

    if (window.innerWidth) {
        if (window.innerWidth < 1281) {
            var headerH = 61;
        } else {
            var headerH = 83;
        }
    }
    // 스크롤 모션
    var scrollAnchorFlag = false;
    function scrollAnchor(target) {
        $(target).each(
            function (index) {
                $(this).on("wheel DOMMouseScroll", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var delta = 0;
                    if (!event) event = window.event;
                    if (event.wheelDelta) {
                        delta = event.wheelDelta / 120;
                        if (window.opera) delta = -delta;
                    } else if (event.detail) delta = -event.detail / 3;
                    var moveTop = $(window).scrollTop();
                    // 마우스휠을 위에서 아래로
                    if (delta < 0) {
                        var tt = "down";
                        if (index + 1 < $(target).length) {
                            moveTop =
                                $(target)
                                    .eq(index + 1)
                                    .offset().top - headerH;
                        } else {
                            moveTop = $(".sclElm_last").offset().top - headerH;
                        }
                        // 마우스휠을 아래에서 위로
                    } else {
                        var tt = "up";
                        if (index - 1 > 0) {
                            moveTop =
                                $(target)
                                    .eq(index - 1)
                                    .offset().top - headerH;
                        } else {
                            moveTop = 0;
                        }
                    }

                    if (!$("body").hasClass("scrollDisable") && scrollAnchorFlag == false) {
                        scrollAnchorFlag = true;
                        // 화면 이동 0.1초(100)
                        $("html,body")
                            .stop()
                            .animate(
                                {
                                    scrollTop: moveTop + "px",
                                },
                                {
                                    duration: 100,
                                    complete: function () {
                                        scrollAnchorFlag = false;
                                        //console.log(tt);
                                    },
                                },
                                1000,
                            );
                    }
                });
            },
            { passive: false },
        );
    }

    // scroll active
    var flag = false;
    var flagCont = false;
    var flagEnd = false;
    var flag2 = false;
    var flagBg = false;
    var flagVisual = false;
    function scrollActive() {
        var position = $(window).scrollTop();
        $(".ani_cont").each(function (e) {
            var posY = $(this).offset().top - headerH - 1;
            var lastPosY = posY + $(this).height();
            if (window.innerWidth < 1281) {
                var removePosY = lastPosY - window.innerHeight / 6;
            } else {
                var removePosY = posY + 30;
            }
            if (position >= posY && position < lastPosY) {
                if (flag == false) {
                    flag = true;
                    $(this).addClass("active");
                    if ($(this).hasClass("ani_cont3")) {
                        $(".ani_cont3 video").get(0).play();
                    }
                    if (position > removePosY) {
                        $(this).addClass("remove");
                    } else {
                        $(this).removeClass("remove");
                    }
                }
            } else {
                $(this).removeClass("active");
                if ($(this).hasClass("ani_cont3")) {
                    $(".ani_cont3 video").get(0).pause();
                }
                flag = false;
            }
        });

        // cont_2 end 추가
        var contEndY = $(".ani_cont3").offset().top - headerH - 1;
        var contEndY2 = $(".ani_cont3").offset().top + $(".ani_cont3").height() - window.innerHeight;
        if (position > contEndY) {
            if (flagEnd == false) {
                flagEnd = true;
                $(".cont_1").addClass("end");
            }
        } else {
            $(".cont_1").removeClass("end");
            flagEnd = false;
        }
        if (position > contEndY2) {
            $(".cont_1").addClass("mo");
        } else {
            $(".cont_1").removeClass("mo");
        }
        var contFir = $(".cont_1").offset().top - headerH - 2;
        var contFirEndY = contFir + $(".cont_1").height();
        if (position > contFir && position < contFirEndY) {
            if (flagCont == false) {
                flagCont = true;
                $(".cont_1").addClass("active");
            }
        } else {
            $(".cont_1").removeClass("active");
            flagCont = false;
        }

        // cont 공통
        $(".cont").each(function (e) {
            var posY = $(this).offset().top - window.innerHeight / 4;
            var posYb = $(this).offset().top + $(this).height() - 84;
            if (position >= posY && position < posYb) {
                if (flag2 == false) {
                    $(this).addClass("active");
                    if ($(this).hasClass("cont_3")) {
                        $(".prime_swiper .pagination button").eq(0).addClass("active");
                        primeSwiper.autoplay.start();
                    }
                    if ($(this).hasClass("cont_5")) {
                        $(".box_wrap .box").eq(0).addClass("active");
                        stepSwiper.autoplay.start();
                    }
                    flag2 = true;
                }
            } else {
                $(this).removeClass("active");
                if ($(this).hasClass("cont_3")) {
                    $(".prime_swiper .pagination button").eq(0).click();
                    $(".prime_swiper .pagination button").removeClass("active");
                    primeSwiper.autoplay.stop();
                }
                if ($(this).hasClass("cont_5")) {
                    $(".box_wrap .box").eq(0).click();
                    $(".box_wrap .box").removeClass("active");
                    stepSwiper.autoplay.stop();
                }
                flag2 = false;
            }
        });
    }

    scrollAnchor(".sclElm");
    scrollActive();
    window.addEventListener("scroll", optimizeAnimation(scrollActive), {
        passive: true,
    });

    //dev add
    $(function () {
        var slideLength = $(".product_item_swiper .swiper-slide").length;
        if ($(window).width() > 768) {
            if (slideLength <= 4) {
                var numindex = slideLength - 1;
            }
            if (slideLength > 4) {
                var numindex = 3;
            }
        }
        if ($(window).width() <= 768) {
            var numindex = 0;
        }
        var displaySwiper = new Swiper(".product_item_swiper", {
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                },
                769: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                    spaceBetween: 40,
                },
            },
            pagination: {
                el: ".product_item_pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: ".product_item_next",
                prevEl: ".product_item_prev",
            },
        });
    });
})();